import React, { Fragment } from "react";
import HomeComponent from "../component/app/home/Home.component";
import { useAuth } from "../context/Auth.context";
import DealershipDetailComponent from "../component/app/admin/dealership/DealershipDetail.component";

const DealersPage = () => {
  const auth = useAuth();

  return (
    <Fragment>
      {auth?.user?.loggedInAs === "admin" ? (
        <DealershipDetailComponent />
      ) : (
        <HomeComponent />
      )}
    </Fragment>
  );
};

export default DealersPage;
